export const useScrollToElement = () => {
    const scrollTo = (id, options = {}) => {
        const el = document.getElementById(id)
        if (!el) return

        el.scrollIntoView({
            behavior: options.behavior ?? 'smooth',
            block: options.block ?? 'start'
        })
    }

    return { scrollTo }
}
